module.exports = __webpack_public_path__ + "img/2.a17e93ce.png";